<script setup lang="ts">
import { ArrowRightIcon } from '@heroicons/vue/24/outline';
import { useCarousel } from './useCarousel';
import type { WithClassAsProps } from './interface';
import { cn } from '@shadcn/lib/utils';
import { ZButton } from '@shadcn/components/ui/button';

const props = defineProps<WithClassAsProps>();

const { orientation, canScrollNext, scrollNext } = useCarousel();
</script>

<template>
  <ZButton
    :disabled="!canScrollNext"
    :class="
      cn(
        'touch-manipulation absolute h-8 w-8 rounded-full p-0',
        orientation === 'horizontal'
          ? '-right-12 top-1/2 -translate-y-1/2'
          : '-bottom-12 left-1/2 -translate-x-1/2 rotate-90',
        props.class,
      )
    "
    variant="outline"
    @click="scrollNext"
  >
    <slot>
      <ArrowRightIcon class="h-4 w-4 text-current" />
    </slot>
  </ZButton>
</template>
